module.exports = __webpack_public_path__ + "static/media/agile-develpment.f271d943.svg";